// extracted by mini-css-extract-plugin
export default {"WelcomeTile":"WelcomeTile_WelcomeTile__nq7bM"};